import React from "react";
import './App.css';
import SortComponent from './SortComponent/SortComponent';

function App() {
  return (
    <div className="App">
      <h1 className="App-header">Sort It Out!</h1>
      <SortComponent></SortComponent>
     
    </div>
  );
}

export default App;
